const loading = ref(false);

/**
 * Can be used to trigger the central application progress bar.
 */
export function useLoading() {
  return { loading };
}
